// extracted by mini-css-extract-plugin
export default {"form":"LandingFormPage_form__aVxI0"};